// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-video-video-inner-bkugj{padding-top:56.25%;position:relative;width:100%}.components-video-video-innerFile-cayme{max-height:80vh;padding-top:0}.components-video-video-wrapper-bexat{align-items:center;display:flex;justify-content:center;width:100%}.components-video-video-frame-bxipo{height:100%;width:100%;bottom:0;left:0;position:absolute;right:0;top:0}.components-video-video-player-oalap{background:#000;max-height:80vh;-o-object-fit:contain;object-fit:contain;position:relative}.components-video-video-error-vkafg{align-items:center;background:var(--color-grayLight);border-radius:12px;color:var(--color-gray);display:flex;justify-content:center;min-height:160px;padding:16px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inner": "components-video-video-inner-bkugj",
	"innerFile": "components-video-video-innerFile-cayme",
	"wrapper": "components-video-video-wrapper-bexat",
	"frame": "components-video-video-frame-bxipo",
	"player": "components-video-video-player-oalap",
	"error": "components-video-video-error-vkafg"
};
module.exports = ___CSS_LOADER_EXPORT___;
